<template>
    <div class="mainBox">
        <div class="main-header">
            <el-row :gutter="10">
                <el-col :span="6">
                    <el-button type="primary" icon='el-icon-plus' size="medium" @click='handleInsert'>新增产品</el-button>
                    <el-button icon='el-icon-refresh' size="medium" @click='getData'>刷新</el-button>
                </el-col>
                <el-col :span="18">
                    <el-form ref="search_form" :model="searchForm" class='search_form'>
                        <el-row :gutter="10">
                            <el-col :span="3" :offset="7">
                                <el-form-item prop="language">
                                    <el-select v-model="searchForm.language" @change='searchFormDatas' placeholder="请选择语言" clearable>
                                        <el-option label="中文" value="cn"></el-option>
                                        <el-option label="英文" value="en"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item prop="title">
                                    <el-input v-model="searchForm.title" size="medium" placeholder="请输入标题" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item prop='times'>
                                    <el-date-picker size="medium" v-model="searchForm.times" :picker-options="pickerOptions" type="daterange"
                                     range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format='yyyy-MM-dd' unlink-panels @change='searchFormDatas'>
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="primary" class="searchBtn" size="medium" icon='el-icon-search' @click='searchFormDatas'>查询</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>
        </div>
        <el-table :data="contentList" border style="width: 100%">
            <el-table-column label="文章ID" width="100" align="center" prop="id">
            </el-table-column>
            <el-table-column label="语言" width="100" align="center" prop="language">
                <template slot-scope="scope">
                    <span v-if="scope.row.language == 'cn'">中文</span>
                    <span v-if="scope.row.language == 'en'">英文</span>
                </template>
            </el-table-column>
            <el-table-column label="分类" align="center" prop="column_id">
                <template slot-scope="scope">
                    <span v-if="scope.row.column_id == '3'">Fully Hydrogenated</span>
                    <span v-if="scope.row.column_id == '4'">Aromatic Modified</span>
                    <span v-if="scope.row.column_id == '5'">Non-Hydrogenated</span>
                </template>
            </el-table-column>
            <el-table-column label="标题" align="center" prop="title">
            </el-table-column>
            <el-table-column label="排序" width="100" align="center" prop="weigh">
            </el-table-column>
            <el-table-column label="创建时间" width="200" align="center" prop="created_at">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="220" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleEdit(scope.row)" type="primary" size="mini" icon="el-icon-edit-outline">编辑</el-button>
                    <el-button @click.native.prevent="handleDel(scope.row)" type="danger" size="mini" icon="el-icon-delete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <div class="pagination-footer" v-show="pagination.totalNum > 0">
            <el-pagination background layout="prev, pager, next" :current-page="pagination.page" :page-size="pagination.pageSize"
             :total="pagination.totalNum" @current-change="pageChangeAction">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {contentList,contentDel} from '@/utils/getData';

    export default {
        name: "newsPage",
        data() {
            return {
                pagination: {
                    page: 1, //当前页数
                    pageSize: 20, //每页显示的条数
                    totalNum: 100 //总条数
                },
                searchForm: {
                    language:'',
                    title: '',
                    type:'products',
                    times: [],
                    start_time: '',
                    end_time: ''
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                contentList: [],
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                contentList(this.pagination.page, this.searchForm).then(res => {
                    if (res.code == 0) {
                        this.pagination.pageSize = res.data.pageSize;
                        this.pagination.totalNum = res.data.count;
                        this.contentList = res.data.rows;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                })
            },
            searchFormDatas() { //表单搜索
                if(this.searchForm.times && this.searchForm.times.length){
                    this.searchForm.start_time = this.searchForm.times[0];
                    this.searchForm.end_time = this.searchForm.times[1];
                }else{
                    this.searchForm.start_time = '';
                    this.searchForm.end_time = '';
                }
                this.getData();
            },
            pageChangeAction(val) {
                this.pagination.page = val;
                this.getData();
            },
            handleInsert() { //新增文章
                this.$router.push("/productsEdit");
            },
            handleEdit(currentRow) { //编辑账号
                this.$router.push("/productsEdit/"+currentRow.id);
            },
            handleDel(currentRow){
                this.$confirm('确定要删除此文章吗？', '删除文章', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    contentDel(currentRow.id).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                showClose: true,
                                message: '删除成功',
                                type: 'success'
                            });
                            const index = this.contentList.findIndex(item=>{
                                return item.id == currentRow.id;
                            });
                            if(index != -1){
                                this.contentList.splice(index,1)
                            }
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped="scoped">

</style>